/**
 * Veeroute.Lastmile
 * Veeroute Lastmile API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Data validation result.
 */
export interface ValidationLastmile { 
    /**
     * Validation type: * `info`  * `warning`  * `error`  
     */
    type: ValidationLastmileTypeEnum;
    /**
     * Entity description.
     */
    entity_key?: string;
    /**
     * Entity type.
     */
    entity_type?: string;
    /**
     * Information about validation.
     */
    info: string;
}
export enum ValidationLastmileTypeEnum {
    INFO = 'info',
    WARNING = 'warning',
    ERROR = 'error'
};



